var map = {
	"./01_rooms-student-room.768.jpg": 3800,
	"./01_rooms-student-room.768.webp": 8892,
	"./01_rooms-student-room.original.jpg": 2184,
	"./01_rooms-student-room.original.webp": 6634,
	"./01_rooms-student-room.thumbnail.jpg": 913,
	"./01_rooms-student-room.thumbnail.webp": 4131,
	"./02_rooms-family-room.768.png": 1738,
	"./02_rooms-family-room.768.webp": 2836,
	"./02_rooms-family-room.original.png": 9838,
	"./02_rooms-family-room.original.webp": 6162,
	"./02_rooms-family-room.thumbnail.png": 7207,
	"./02_rooms-family-room.thumbnail.webp": 299,
	"./03_rooms-deluxe-room.768.jpg": 9064,
	"./03_rooms-deluxe-room.768.webp": 4986,
	"./03_rooms-deluxe-room.original.jpg": 6008,
	"./03_rooms-deluxe-room.original.webp": 2668,
	"./03_rooms-deluxe-room.thumbnail.jpg": 3089,
	"./03_rooms-deluxe-room.thumbnail.webp": 4673,
	"./04_rooms-shared-bed-&-lockers.768.jpg": 1092,
	"./04_rooms-shared-bed-&-lockers.768.webp": 6692,
	"./04_rooms-shared-bed-&-lockers.original.jpg": 7884,
	"./04_rooms-shared-bed-&-lockers.original.webp": 2834,
	"./04_rooms-shared-bed-&-lockers.thumbnail.jpg": 7685,
	"./04_rooms-shared-bed-&-lockers.thumbnail.webp": 1163,
	"./05_sink.768.png": 871,
	"./05_sink.768.webp": 4401,
	"./05_sink.original.png": 7609,
	"./05_sink.original.webp": 8033,
	"./05_sink.thumbnail.png": 8570,
	"./05_sink.thumbnail.webp": 1618,
	"./06_toilet.768.png": 4311,
	"./06_toilet.768.webp": 2920,
	"./06_toilet.original.png": 3892,
	"./06_toilet.original.webp": 926,
	"./06_toilet.thumbnail.png": 8913,
	"./06_toilet.thumbnail.webp": 2951,
	"./07_bathroom-1.768.png": 4384,
	"./07_bathroom-1.768.webp": 304,
	"./07_bathroom-1.original.png": 7048,
	"./07_bathroom-1.original.webp": 2326,
	"./07_bathroom-1.thumbnail.png": 7813,
	"./07_bathroom-1.thumbnail.webp": 9567,
	"./08_bathroom-2.768.png": 4430,
	"./08_bathroom-2.768.webp": 9394,
	"./08_bathroom-2.original.png": 2570,
	"./08_bathroom-2.original.webp": 1927,
	"./08_bathroom-2.thumbnail.png": 8403,
	"./08_bathroom-2.thumbnail.webp": 9993,
	"./09_rooms-amenities.768.png": 784,
	"./09_rooms-amenities.768.webp": 3482,
	"./09_rooms-amenities.original.png": 9624,
	"./09_rooms-amenities.original.webp": 972,
	"./09_rooms-amenities.thumbnail.png": 5413,
	"./09_rooms-amenities.thumbnail.webp": 7873,
	"./10_desk.768.png": 1139,
	"./10_desk.768.webp": 4745,
	"./10_desk.original.png": 1005,
	"./10_desk.original.webp": 7094,
	"./10_desk.thumbnail.png": 3457,
	"./10_desk.thumbnail.webp": 2426,
	"./11_lockers.768.png": 1258,
	"./11_lockers.768.webp": 5748,
	"./11_lockers.original.png": 446,
	"./11_lockers.original.webp": 8226,
	"./11_lockers.thumbnail.png": 9831,
	"./11_lockers.thumbnail.webp": 9371,
	"./12_kitchen-1.768.png": 6448,
	"./12_kitchen-1.768.webp": 8310,
	"./12_kitchen-1.original.png": 5432,
	"./12_kitchen-1.original.webp": 9632,
	"./12_kitchen-1.thumbnail.png": 7669,
	"./12_kitchen-1.thumbnail.webp": 8741,
	"./13_kitchen-2.768.png": 2934,
	"./13_kitchen-2.768.webp": 504,
	"./13_kitchen-2.original.png": 9474,
	"./13_kitchen-2.original.webp": 1886,
	"./13_kitchen-2.thumbnail.png": 5467,
	"./13_kitchen-2.thumbnail.webp": 7847,
	"./14_lounge-1.768.png": 1864,
	"./14_lounge-1.768.webp": 6236,
	"./14_lounge-1.original.png": 5840,
	"./14_lounge-1.original.webp": 1101,
	"./14_lounge-1.thumbnail.png": 7725,
	"./14_lounge-1.thumbnail.webp": 5251,
	"./15_lounge-2.768.png": 4636,
	"./15_lounge-2.768.webp": 2672,
	"./15_lounge-2.original.png": 1756,
	"./15_lounge-2.original.webp": 5862,
	"./15_lounge-2.thumbnail.png": 9465,
	"./15_lounge-2.thumbnail.webp": 2383,
	"./16_computer-lab.768.png": 4799,
	"./16_computer-lab.768.webp": 1273,
	"./16_computer-lab.original.png": 4833,
	"./16_computer-lab.original.webp": 8249,
	"./16_computer-lab.thumbnail.png": 66,
	"./16_computer-lab.thumbnail.webp": 4442,
	"./17_common-area.768.png": 572,
	"./17_common-area.768.webp": 2126,
	"./17_common-area.original.png": 7644,
	"./17_common-area.original.webp": 8872,
	"./17_common-area.thumbnail.png": 4345,
	"./17_common-area.thumbnail.webp": 9453,
	"./18_building.768.png": 6512,
	"./18_building.768.webp": 904,
	"./18_building.original.png": 8840,
	"./18_building.original.webp": 9054,
	"./18_building.thumbnail.png": 9557,
	"./18_building.thumbnail.webp": 7543,
	"./19_balcony.768.png": 3294,
	"./19_balcony.768.webp": 3341,
	"./19_balcony.original.png": 7039,
	"./19_balcony.original.webp": 6693,
	"./19_balcony.thumbnail.png": 684,
	"./19_balcony.thumbnail.webp": 9094,
	"./20_parking.768.png": 241,
	"./20_parking.768.webp": 2330,
	"./20_parking.original.png": 3695,
	"./20_parking.original.webp": 4549,
	"./20_parking.thumbnail.png": 8764,
	"./20_parking.thumbnail.webp": 8198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9448;